import { Col, Row, Space } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { EmailConfig } from 'api/account';
import { AddButton, Button } from 'components/atoms/button';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslation } from 'hooks/use-translation';
import { SettingsLabelWithoutMargin } from '../../styles';
import { VerifiedText } from '../styles';

const Domain = styled(SettingsLabelWithoutMargin)`
  color: var(--blue-60);
  font-weight: bold;
`;

export const Header: FC<{
  config: Omit<EmailConfig, 'spf' | 'dkim1' | 'dkim2'>;
  onDelete: (emailDomain: string) => void;
  onVerify: (emailDomain: string) => void;
  loading: boolean;
}> = ({ config, onDelete, loading = false, onVerify }) => {
  const deleteTitle = useTranslation('delete_domain');
  const deleteMessage = useTranslation(
    'settings.email_configuration.delete.content',
    { domain: config.emailDomain },
  );

  const deleteDomain = useDeleteConfirmModal({
    title: deleteTitle,
    content: deleteMessage,
    onOk() {
      if (config.emailDomain) {
        return onDelete(config.emailDomain);
      }

      return false;
    },
  });

  return (
    <Row justify="space-between" align="middle">
      <Col>
        <Space size={32}>
          <Domain>{config.emailDomain}</Domain>
          <Space align="center">
            <span>
              <FormattedMessage id="status" />
            </span>
            <VerifiedText verified={config.verified}>
              {config.verified ? (
                <FormattedMessage id="verified" />
              ) : (
                <FormattedMessage id="not_verified" />
              )}
            </VerifiedText>
          </Space>
        </Space>
      </Col>
      <Col>
        <Space align="center" size="large">
          <Button
            type="text"
            danger
            onClick={() => deleteDomain()}
            disabled={loading}
          >
            <FormattedMessage id="delete_domain" />
          </Button>

          {config.verified ? null : (
            <AddButton
              disabled={loading}
              loading={loading}
              onClick={() => onVerify(config.emailDomain)}
            >
              <FormattedMessage id="verify" />
            </AddButton>
          )}
        </Space>
      </Col>
    </Row>
  );
};
